
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Der grösste Beizer in der Stadt Bern mit neun Restaurants ist der Zürcher
  Frauenverein (ZFV): Schöngrün, Zum Äusseren Stand, Mishio Vatterland, Haus der
  Universität, Lilly Jo, Henris, Grosse Schanze, Mobilcity und Dählhölzli. Zu
  den neun öffentlichen Restaurants kommen zehn Personalrestaurants hinzu.
    </p>
    <p>
  Der ZFV wurde 1894 als «Frauenverein für Mässigkeit und Volkswohl» in Zürich
  gegründet. Nach der ersten Kaffeestube ging ein Lokal nach dem anderen auf.
  Bald folgten Hotels. Die Genossenschaft wollte damals gegen übermässigen
  Alkoholkonsum kämpfen. Visionär war, dass schon 1908 Unfallversicherung und
  Ferien bezahlt wurden und die Mitarbeiterinnen einen halben Tag pro Woche frei
  bekamen. Anstatt Trinkgeld gab es einen Fixlohn. 1914 stieg man in die
  Gemeinschaftsgastronomie ein, ab 1990 in die Personalverpflegung,
  beispielsweise bei der UBS.
    </p>
    <Image file={require('images/zfv_2.jpg')} source='Im «Zum Äusseren Stand» finden auf zwei Etagen 286 Gäste Platz. Bild: Raphael Moser' mdxType="Image" />
    <p>
  Lange beschränkte sich der ZFV auf den Grossraum Zürich, bis die UBS ihm im
  Jahr 2000 zwei Personalrestaurants in Bern übergab. In der Bundesstadt richtig
  Fuss zu fassen, dauerte weitere fünf Jahre: Ein Meilenstein war 2005, als das
  Restaurant Schöngrün beim Zentrum Paul Klee gepachtet wurde. Drei Jahre später
  übernahm der ZFV die Verpflegung des Bundeshauspersonals. 2018 kam das
  Restaurant Zum Äusseren Stand in der Zeughausgasse hinzu. Die neueste
  Eröffnung war letztes Jahr das Lilly Jo beim Inselspital, welches als
  öffentliches Lokal, aber auch als Personalrestaurant funktioniert.
    </p>
    <p>
  Schweizweit führt der ZFV über 200 eigene und im Auftrag gemanagte Betriebe
  und beschäftigt 2800 Personen. «Im Fokus steht für uns nicht die Menge an
  Betrieben, sondern dass wir überall als sympathische Gastgeber auftreten»,
  sagt eine ZFV-Sprecherin. Der schweizweite Umsatz lag letztes Jahr bei 284,2
  Millionen Franken. In der Stadt Bern erwirtschaftete die Genossenschaft einen
  Umsatz von 49,9 Millionen Franken.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;